import moment from 'moment';

// ISO string ya da ms değerini epoch-ms'e çevir (geçersizse null).
export const toMs = (v: string | number | null | undefined): number | null => {
  if (v == null) return null;
  const n = typeof v === 'number' ? v : Date.parse(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * "Son görülme" metni (WhatsApp tarzı). Kullanıcı çevrimiçiyse çağıran taraf
 * 'Çevrimiçi' göstermeli — bu yalnızca çevrimdışı zaman damgasını biçimlendirir.
 * Sayısal tarih formatı kullanır (locale'den bağımsız).
 */
export const formatLastSeen = (ms: number | null): string => {
  if (ms == null) return 'çevrimdışı';
  const m = moment(ms);
  const now = moment();
  const diffMin = now.diff(m, 'minutes');
  if (diffMin < 1) return 'az önce';
  if (diffMin < 60) return `${diffMin} dk önce`;
  if (m.isSame(now, 'day')) return `bugün ${m.format('HH:mm')}`;
  if (m.isSame(now.clone().subtract(1, 'day'), 'day')) return `dün ${m.format('HH:mm')}`;
  if (m.isSame(now, 'year')) return m.format('DD.MM HH:mm');
  return m.format('DD.MM.YYYY');
};
